import { create } from 'zustand';
import type { Call, Device } from '@twilio/voice-sdk';

export type AgentStatus = 'Available' | 'Away' | 'Offline' | 'In-call';
export type SettableStatus = Exclude<AgentStatus, 'In-call'>;

interface DeviceState {
  device: Device | undefined;
  ready: boolean;
  audioUnlocked: boolean;
  status: AgentStatus;
  incomingCall: Call | undefined;
  activeCall: Call | undefined;
  callStartedAt: number | undefined;

  setDevice: (d: Device | undefined) => void;
  markReady: (ready: boolean) => void;
  unlockAudio: () => void;
  setStatus: (s: AgentStatus) => void;
  setIncoming: (c: Call | undefined) => void;
  setActive: (c: Call | undefined) => void;
}

export const useDeviceStore = create<DeviceState>(set => ({
  device: undefined,
  ready: false,
  audioUnlocked: false,
  status: 'Offline',
  incomingCall: undefined,
  activeCall: undefined,
  callStartedAt: undefined,

  setDevice: device => set({ device }),
  markReady: ready => set({ ready }),
  unlockAudio: () => set({ audioUnlocked: true }),
  setStatus: status => set({ status }),
  setIncoming: incomingCall => set({ incomingCall }),
  setActive: activeCall => set({ activeCall, callStartedAt: activeCall ? Date.now() : undefined }),
}));
